import { always } from "ramda";

import { Routes } from "../../../../router/types";
import { isMainRouteWithFormValidator } from "../../../../utilities/matchers";

import { createSingleRoute, ConnectedSingleRoute } from ".";

export const singleRoutesFactory = (
  routes: Routes,
  currentRoute: string
): JSX.Element[] =>
  routes.map((route, index) => {
    if (isMainRouteWithFormValidator(route)) {
      return (
        <ConnectedSingleRoute
          key={[route.name, route.path].join("-")}
          currentRoute={currentRoute}
          route={route}
        >
          {++index}
        </ConnectedSingleRoute>
      );
    }

    return createSingleRoute({
      ...route,
      children: ++index,
      currentRoute,
      isActive: false,
      isValidated: false,
      onClickHandler: always,
    });
  });
